module.exports = __webpack_public_path__ + "img/744.a0fc5d84.jpg";